// generated from 136 samples

import { z } from "zod";
import { common } from "../common";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const pushOptInSinceFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("push_opt_in_since_filter"),
  comparison_key: z.enum([
    "4", // 76 (55.88%)
    "6", // 40 (29.41%)
    "3", // 19 (13.97%)
    "5", // 1 (0.74%)
  ]),
  display_name: z.string(),
  // undefined: 82 (60.29%), defined 54 (39.71%)
  raw_value: z
    .union([
      // number samples: 44 (81.48%)
      // integer: 43 (97.73%)
      // avg: 24.82, min: 0.08333333333333333, max: 35
      z.number().nonnegative(),
      // string samples: 10 (18.52%)
      common.date,
    ])
    .optional(),
  value: z.union([
    // number samples: 116 (85.29%)
    // integer: 115 (99.14%)
    // avg: 85.17, min: 0.08333333333333333, max: 366
    z.number().nonnegative(),
    // string samples: 20 (14.71%)
    common.date,
  ]),
  varies_by_app_group: z.literal(false),
});
